/**
 * Format an integer with dot thousand separators (e.g. 300000 → "300.000").
 * Matches the server-side GemsWeb.Utils.format_currency/1.
 */
export function formatAmount(n) {
  const num = typeof n === "string" ? parseInt(n.replace(/\./g, ""), 10) : n;
  if (isNaN(num)) return "0";
  const str = Math.abs(Math.round(num)).toString();
  if (str.length <= 3) return str;
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

/**
 * Strip dot thousand separators and parse as integer.
 * Returns NaN if the string is not a valid number.
 */
export function parseAmount(s) {
  if (typeof s !== "string") return typeof s === "number" ? s : NaN;
  return parseInt(s.replace(/\./g, ""), 10);
}
